import React, { useState, useEffect } from "react";
import { storage, ref,  getDownloadURL, listAll } from "./FireBase";
import "./VideoImage.css"; 


const VideoImage = () => {

  const [files, setFiles] = useState([]);



  const fetchFiles = async () => {
    try {
      const listRef = ref(storage, "uploads/"); 
      const result = await listAll(listRef);
  
      // Fetch filenames, URLs, and categorize by file type
      const filesData = await Promise.all(
        result.items.map(async (item) => {
          const url = await getDownloadURL(item);
          const filename = item.name;
  
          // Extract file extension
          const extension = filename.split('.').pop().toLowerCase();
  
          // Define categories based on extensions
          let fileType = "other"; // Default category
          const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
          const videoExtensions = ["mp4", "mkv", "avi", "mov", "wmv", "flv"];
  
          if (imageExtensions.includes(extension)) {
            fileType = "image";
          } else if (videoExtensions.includes(extension)) {
            fileType = "video";
          }
  
          return { filename, url, fileType };
        })
      );
  
      console.log(filesData);
      setFiles(filesData);  // Update state with categorized files
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };
  

  useEffect(() => {
    fetchFiles();
  }, []);

  return (
<div className="outervideocontainer">
  <h2>Videos</h2>

  <div className="filesvideo-container">
    {files
      .filter((file) => file.fileType === "video") // Only render video files
      .map((file, index) => (
        <div className="videocontainer" key={index}>
          <div className="innervideocontainer">
            {/* Video or Link based on file type */}
            {file.fileType === "video" ? (
              <video controls>
                <source src={file.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <a href={file.url} target="_blank" rel="noopener noreferrer">
                {file.filename}
              </a>
            )}
          </div>
          <p>{file.filename}</p>
        </div>
      ))}
  </div>
</div>

  );
};

export default VideoImage;
